import axiosInstance from "../config/axiosConfig";
import { ApiToken, CreatedApiToken } from "../model/token.model";

export const TokensService = {
  list: async () => axiosInstance.get<ApiToken[]>('api/tokens'),
  create: async (name: string, expiresInDays: number | null) =>
    axiosInstance.post<CreatedApiToken>('api/tokens', { name, expiresInDays }),
  revoke: async (id: number) => axiosInstance.delete(`api/tokens/${id}`),
};
